/* AXELCORE interactions */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;

  function reveal() {
    if (reduce || design || !('IntersectionObserver' in window)) return;
    root.classList.add('ax-motion');
    var els = document.querySelectorAll('.ax-rise, .ax-wipe');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 5000);
  }

  function setCharge(bar, pct) {
    var cells = bar.querySelectorAll('i');
    var on = Math.round((Math.max(0, Math.min(100, pct)) / 100) * cells.length);
    cells.forEach(function (c, i) { c.classList.toggle('on', i < on); });
  }
  function initCharge() {
    document.querySelectorAll('[data-ax-charge]').forEach(function (bar) {
      var target = parseFloat(bar.getAttribute('data-ax-charge')) || 0;
      if (reduce || !bar.hasAttribute('data-ax-animate')) return setCharge(bar, target);
      var p = 0;
      setCharge(bar, 0);
      var t = setInterval(function () { p += 5; setCharge(bar, p); if (p >= target) clearInterval(t); }, 70);
    });
  }

  function addToCart(items, btn) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) body.sections = 'cart-drawer,cart-icon-bubble';
    if (btn) btn.classList.add('is-loading');
    var holder = btn && (btn.closest('[data-ax-buy]') || btn.closest('.ax-card__body') || btn.closest('.ax-bundle__sum') || btn.parentElement);
    var msg = holder && holder.querySelector('[data-ax-msg]');
    if (msg) msg.textContent = '';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-loading');
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
        if (drawer && res.j.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.j);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        if (btn) btn.classList.remove('is-loading');
        if (msg) msg.textContent = err.message;
      });
  }
  function initAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ax-add]');
      if (!btn) return;
      e.preventDefault();
      var ids = btn.getAttribute('data-ax-add').split(',');
      var qty = parseInt(btn.getAttribute('data-ax-qty') || '1', 10);
      var scope = btn.getAttribute('data-ax-scope');
      var form = scope ? document.querySelector(scope) : btn.closest('[data-ax-buy]');
      if (form) {
        var checked = form.querySelector('[data-ax-tier]:checked');
        if (checked) qty = parseInt(checked.value, 10);
      }
      addToCart(ids.map(function (id) { return { id: parseInt(id, 10), quantity: ids.length > 1 ? 1 : qty }; }), btn);
    });
  }

  function initTiers() {
    document.querySelectorAll('[data-ax-buy]').forEach(function (form) {
      var update = function () {
        var c = form.querySelector('[data-ax-tier]:checked');
        if (!c) return;
        var label = form.querySelector('[data-ax-label]');
        if (label) label.textContent = c.getAttribute('data-label');
        var st = document.querySelector('[data-ax-sticky-label]');
        if (st) st.textContent = c.getAttribute('data-short');
        var bar = form.querySelector('[data-ax-charge]');
        if (bar) setCharge(bar, parseFloat(c.getAttribute('data-pct')));
        var txt = form.querySelector('[data-ax-charge-text]');
        if (txt) txt.innerHTML = c.getAttribute('data-ship');
        var pct = form.querySelector('[data-ax-charge-pct]');
        if (pct) pct.textContent = c.getAttribute('data-pct') + '%';
      };
      form.addEventListener('change', function (e) { if (e.target.matches('[data-ax-tier]')) update(); });
      update();
    });
  }

  function initGallery() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ax-thumb]');
      if (!t) return;
      var g = t.closest('[data-ax-gallery]');
      var main = g.querySelector('[data-ax-main]');
      if (main) { main.removeAttribute('srcset'); main.src = t.getAttribute('data-src'); }
      g.querySelectorAll('[data-ax-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-ax-tabs]').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('[role=tab]');
      var timer;
      var go = function (i, user) {
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.classList.toggle('is-active', on);
        });
        if (user) clearInterval(timer);
      };
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { go(i, true); });
        t.addEventListener('keydown', function (e) {
          var k = -1;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') k = (i + 1) % tabs.length;
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') k = (i - 1 + tabs.length) % tabs.length;
          if (k > -1) { e.preventDefault(); go(k, true); tabs[k].focus(); }
        });
      });
      if (!reduce && !design && tabs.length > 1) {
        var idx = 0;
        timer = setInterval(function () { idx = (idx + 1) % tabs.length; go(idx); }, 6500);
        wrap.addEventListener('mouseenter', function () { clearInterval(timer); }, { once: true });
        wrap.addEventListener('touchstart', function () { clearInterval(timer); }, { once: true, passive: true });
      }
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-ax-sticky]');
    var main = document.querySelector('[data-ax-main-add]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      bar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
    }).observe(main);
  }

  function init() { reveal(); initCharge(); initAdd(); initTiers(); initGallery(); initTabs(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.AX = { add: addToCart };
})();
